import { createStore, reconcile } from 'solid-js/store';
export function createReconciledStore(initialData) {
    const [store, setStore] = createStore(initialData);
    const updateStore = (data) => {
        if (typeof data === 'function') {
            const newData = data(store);
            setStore(reconcile(newData));
        }
        else {
            setStore(reconcile(data));
        }
    };
    return [store, updateStore];
}
